import React from 'react'
import HeroSection from '../HeroSection/HeroSection'
import TourTypeSection from '../TourTypeSection/TourTypeSection'
import TourPackageSection from '../TourPackageSection/TourPackageSection'
import HolidaySection from '../HolidaySection/HolidaySection'
import DestinationSection from '../DestinationSection/DestinationSection'
import NormalTourPackage from '../NormalTourPackage/NormalTourPackage'
import PlanTripSection from '../PlanTripSection/PlanTripSection'
import ZikRmeProPlan from '../ZikRmeProPlan/ZikRmeProPlan'
import FAQSection from '../FAQSection/FAQSection'
import TrustSupportSection from '../TrustSupportSection/TrustSupportSection'
import WeekendGetaway from '../WeekendGateway/WeekendGetaway'
import FooterSection from '../FooterSection/FooterSection'

const Home = () => {
  return (
    <div>
      <HeroSection />
      <TourTypeSection />
      <WeekendGetaway />
      <TourPackageSection />

      <HolidaySection />
      <DestinationSection />
      <NormalTourPackage />
      <PlanTripSection />
      <ZikRmeProPlan />
      <FAQSection />
      <TrustSupportSection />
      <FooterSection/>
    </div>
  );
}

export default Home